package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Keychain(
  public val id: String,
  public val name: String,
  public val icon: String,
  public val color: String,
  public val wrapped_key: String,
  public val kdf: String,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
